/* eslint-disable */
import { HintsType } from '../ContactSearchPanelEnum';
export default {
  [HintsType.thirdPartyNoRecordsContent]:
    'Inserisci almeno {minimumLength} caratteri o cifre per cercare tutti i record di {sourceName}.',
  [HintsType.noFilterOrSearchRecordsTitle]: 'Nessun risultato trovato',
  [HintsType.noFilterOrSearchRecordsContent]:
    'Controlla i risultati da altre fonti o modifica la parola chiave.',
  [HintsType.searching]: 'Ricerca in corso...',
  companyTabTitle: 'Azienda',
  personalTabTitle: 'Personale',
  direct: 'Diretto',
  extension: 'Int.',
  contact: 'Contatto',
  mobile: 'Cellulare',
  company: 'Azienda',
  home: 'Home',
  home2: 'Home',
  other: 'Altro',
  business: 'Lavoro',
  business2: 'Lavoro',
  car: 'Automobile',
  fax: 'Fax',
  assistant: 'Assistente',
  callback: 'Richiamata',
  MobileNumber: 'Numero di cellulare',
  ContactNumber: 'Numero di contatto',
  DirectNumber: 'Numero diretto',
  doNotCall: 'Non chiamare',
} as const;

// @key: @#@"[HintsType.thirdPartyNoRecordsContent]"@#@ @source: @#@"Enter at least {minimumLength} characters or digits to search all {sourceName} records."@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsTitle]"@#@ @source: @#@"No results found"@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsContent]"@#@ @source: @#@"Check results from other sources or change your keyword."@#@
// @key: @#@"[HintsType.searching]"@#@ @source: @#@"Searching..."@#@
// @key: @#@"companyTabTitle"@#@ @source: @#@"Company"@#@
// @key: @#@"personalTabTitle"@#@ @source: @#@"Personal"@#@
// @key: @#@"direct"@#@ @source: @#@"Direct"@#@
// @key: @#@"extension"@#@ @source: @#@"Ext"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"home"@#@ @source: @#@"Home"@#@
// @key: @#@"home2"@#@ @source: @#@"Home"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"business"@#@ @source: @#@"Business"@#@
// @key: @#@"business2"@#@ @source: @#@"Business"@#@
// @key: @#@"car"@#@ @source: @#@"Car"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"assistant"@#@ @source: @#@"Assistant"@#@
// @key: @#@"callback"@#@ @source: @#@"Callback"@#@
// @key: @#@"MobileNumber"@#@ @source: @#@"Mobile Number"@#@
// @key: @#@"ContactNumber"@#@ @source: @#@"Contact Number"@#@
// @key: @#@"DirectNumber"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
